import Navbar from "@/components/Common/Navbar";
import { useGetServiceStatus } from "../api/status.queries";
import ServiceStatus from "../components/ServiceStatus";
import { useNavigate } from "@tanstack/react-router";

export default function ServiceStatusContainer() {
  const { data: serviceStatus, isLoading } = useGetServiceStatus();

  const navigate = useNavigate();

  const goToContact = () => {
    navigate({ to: "/", search: { section: "section5" } });
  };

  return (
    <div className="flex h-full w-full flex-col justify-start">
      <div className="p-3 pl-6">
        <Navbar />
      </div>
      <div className="-mt-12 flex w-full flex-1 flex-col items-center justify-center gap-5 px-6 sm:px-12 md:px-20 lg:px-32">
        <div className="flex flex-col items-center justify-center gap-5">
          {/* Preload both images immediately so the browser fetches them in
              parallel with the API call, not after it resolves. */}
          <img
            src="/status/boat.svg"
            alt=""
            aria-hidden
            className="hidden"
            fetchPriority="high"
          />
          <img
            src="/status/storm.svg"
            alt=""
            aria-hidden
            className="hidden"
            fetchPriority="low"
          />

          {isLoading ? (
            <div className="h-44 w-52 animate-pulse rounded-xl bg-neutral-200" />
          ) : serviceStatus?.status === "healthy" ? (
            <img src="/status/boat.svg" alt="boat" className="h-44 w-52" />
          ) : (
            <img src="/status/storm.svg" alt="storm" className="h-80 w-88" />
          )}

          <div className="space-y-1 text-center">
            {/* Heading skeleton or actual heading */}
            {isLoading ? (
              <div className="mx-auto h-12 w-96 animate-pulse rounded-lg bg-neutral-200" />
            ) : serviceStatus?.status === "healthy" ? (
              <h1 className="text-[48px] leading-20 font-bold -tracking-wide text-neutral-950">
                Everything's smooth sailing
              </h1>
            ) : (
              <h1 className="text-[48px] leading-20 font-bold -tracking-wide text-neutral-950">
                Stormy waters ahead
              </h1>
            )}

            <p className="text-md leading-normal font-medium tracking-normal text-neutral-800">
              Having trouble? &nbsp;
              <a className="cursor-pointer underline" onClick={goToContact}>
                Contact support
              </a>
              &nbsp;or email us at &nbsp;
              <a className="cursor-pointer underline" onClick={goToContact}>
                support@metawhale.com
              </a>
            </p>
          </div>
        </div>

        {/* ServiceStatus already has its own isLoading skeleton — just pass it through */}
        <ServiceStatus data={serviceStatus} isLoading={isLoading} />
      </div>
    </div>
  );
}
